import { useSharedLoan } from 'context/SharedLoanContext'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ButtonGroup } from 'stories/components'

import AllTransactionsTab from './AllTransactionsTab'
import { TRUST_LEDGER_DEFAULT_TAB, TRUST_LEDGER_SUB_TABS, TRUST_LEDGER_TABS } from './constants'
import ConstructionReserveTab from './ConstructionReserveTab'
import SharedTrustLedgerView from './SharedTrustLedgerView'
import SubLedgerTab from './SubLedgerTab'
import TrustAccountsPanel from './TrustAccountsPanel'

/**
 * The Draw disbursement Ledger was folded into Construction Reserve, which shows the same draws.
 * A link or bookmark still naming it lands there rather than falling back to the default tab.
 */
const LEGACY_TABS: Record<string, string> = { draw: 'constructionReserve' }

/**
 * Trust Ledger shell. All leads and is where the screen lands, rolling every category up
 * into one read-only grid; the construction-reserve table follows, then the sub-ledgers
 * that used to live on the standalone Escrow Ledger screen.
 */
export default function TrustLedger() {
  const shared = useSharedLoan()
  const isShared = !!shared?.readOnly
  const location = useLocation()
  const navigate = useHistory()

  const requested = new URLSearchParams(location.search).get('tab') || ''
  const requestedTab = LEGACY_TABS[requested] || requested
  const [tab, setTab] = useState(TRUST_LEDGER_TABS[requestedTab] ? requestedTab : TRUST_LEDGER_DEFAULT_TAB)

  useEffect(() => {
    if (TRUST_LEDGER_TABS[requestedTab] && requestedTab !== tab) setTab(requestedTab)
  }, [requestedTab])

  const onChangeTab = (value: string) => {
    if (isShared) return
    setTab(value)
    const params = new URLSearchParams(location.search)
    params.set('tab', value)
    navigate.replace(`${location.pathname}?${params.toString()}`)
  }

  if (isShared) {
    return (
      <div className="TrustLedger-container">
        <div className="max-w-screen-2xl m-auto">
          <h2 className="text-2xl flex items-center gap-1 font-bold mb-2">
            <span>Trust Ledger</span>
          </h2>
          <SharedTrustLedgerView pageData={shared.pageData} />
        </div>
      </div>
    )
  }

  return (
    <div className="TrustLedger-container">
      <div className="max-w-screen-2xl m-auto">
        <h2 className="text-2xl flex items-center gap-1 font-bold mb-2">
          <span>Trust Ledger</span>
        </h2>
        <TrustAccountsPanel />
        <div className="mb-4">
          <ButtonGroup title={TRUST_LEDGER_TABS} onChange={onChangeTab} value={tab} />
        </div>

        {tab === 'constructionReserve' && <ConstructionReserveTab />}
        {TRUST_LEDGER_SUB_TABS.includes(tab) && <SubLedgerTab key={tab} tabType={tab} title={TRUST_LEDGER_TABS[tab]} />}
        {tab === 'all' && <AllTransactionsTab />}
      </div>
    </div>
  )
}
